const zendeskKey = window.env.VUE_APP_ZENDESK_KEY;

const renderWidget = () => {
  if (!document.getElementById("ze-snippet")) {
    const script = document.createElement("script");
    script.setAttribute("id", "ze-snippet");
    script.setAttribute("src", `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`);
    document.body.appendChild(script);
    return script;
  }
};

export default { renderWidget };
